<template>
  <div class="mine-container">
    <div class="mine-header">
      <div class="title">我的工作台</div>
    </div>
    <div class="card-section">
      <div class="section-title">项目管理</div>
      <div class="card-list first grid">
        <div class="card tile highlight" @click="goCheckIn">
          <van-icon name="photograph" class="card-icon red big"/>
          <div class="card-text center">今日打卡</div>
        </div>
        <div class="card tile" @click="goTaxQuery">
          <van-icon name="gold-coin-o" class="card-icon green big"/>
          <div class="card-text center">个税计算器</div>
        </div>
        <div class="card tile" @click="goUpload">
          <van-icon name="upgrade" class="card-icon green big"/>
          <div class="card-text center">上传交付物</div>
        </div>
      </div>
    </div>
    <div class="card-section">
      <div class="section-title">个人中心</div>
      <div class="card-list">
        <div class="card" @click="goMyProject">
          <van-icon name="todo-list-o" class="card-icon"/>
          <div class="card-text">我的项目</div>
          <van-icon name="arrow" class="card-arrow"/>
        </div>
        <div class="card" @click="goSettlement">
          <van-icon name="records" class="card-icon orange"/>
          <div class="card-text">结算记录</div>
          <van-icon name="arrow" class="card-arrow"/>
        </div>
        <div class="card" @click="goTax">
          <van-icon name="balance-list" class="card-icon purple"/>
          <div class="card-text">个税明细</div>
          <van-icon name="arrow" class="card-arrow"/>
        </div>
        <div class="card" @click="goUserInfo">
          <van-icon name="contact" class="card-icon red"/>
          <div class="card-text">我的信息</div>
          <van-icon name="arrow" class="card-arrow"/>
        </div>
        <div class="card" @click="goAbout">
          <van-icon name="info-o" class="card-icon gray"/>
          <div class="card-text">关于我们</div>
          <van-icon name="arrow" class="card-arrow"/>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
  </div>
</template>
<script>
import footerMenu from '@/components/footer/FooterMenu'
export default {
  name: 'Mine',
  components: { footerMenu },
  methods: {
    goCheckIn () { this.$router.push({ name: 'CheckIn' }) },
    goTaxQuery () { window.location.href = 'https://tax.linkscloud.com.cn/' },
    goMyProject () { this.$router.push({ name: 'myPro' }) },
    goUpload () { this.$router.push({ name: 'uploadDeliverables' }) },
    goSettlement () { this.$router.push({ name: 'settlement' }) },
    goTax () { this.$router.push({ name: 'tax' }) },
    goUserInfo () { this.$router.push({ name: 'userInfo' }) },
    goAbout () { this.$router.push({ name: 'about' }) }
  }
}
</script>
<style scoped>
.mine-container{
  background: #f6f8fc;
  min-height: calc(100% - 100px);
  padding-bottom: 20px;
  --header-height: clamp(120px, 22vw, 160px);
  --title-size: clamp(20px, 6.2vw, 28px);
  --section-title-size: clamp(18px, 5.6vw, 22px);
  --card-padding: clamp(14px, 4.5vw, 20px);
  --icon-size: clamp(24px, 6.4vw, 32px);
  --text-size: clamp(14px, 4.8vw, 18px);
  --arrow-size: clamp(16px, 5vw, 20px);
  --stack-gap: clamp(10px, 3.6vw, 14px);
  --lift-overlap: clamp(24px, 7vw, 36px);
}
.mine-header{
  height: var(--header-height);
  background: linear-gradient(135deg, #3b7cff 0%, #5bb4ff 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
.mine-header .title{
  font-size: var(--title-size);
  font-weight: 700;
}
.card-list{
  margin: 0 16px var(--stack-gap);
}
.card-list.first{
  margin: var(--stack-gap) 16px var(--stack-gap);
}
.card-list.first.grid{
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--stack-gap);
}
.card-list.first.grid .card{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: calc(var(--card-padding) * 1.2);
  aspect-ratio: 1 / 1;
}
.card-list.first.grid .card-icon{
  font-size: calc(var(--icon-size) * 1.4);
  margin-bottom: calc(var(--stack-gap) * 0.6);
}
.card-list.first.grid .card-text{
  font-size: calc(var(--text-size) * 1.2);
  text-align: center;
}
.card-section{
  margin-top: var(--stack-gap);
}
.section-title{
  font-size: var(--section-title-size);
  font-weight: 700;
  color: #162336;
  margin: 4px 16px 10px;
  text-align: left;
  display: flex;
  align-items: center;
  padding-left: 12px;
  position: relative;
}
.section-title::before{
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 1.2em;
  border-radius: 999px;
  background: linear-gradient(135deg, #3b7cff, #5bb4ff);
}
.card{
  display: flex;
  align-items: center;
  padding: var(--card-padding);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 14px 28px rgba(59,124,255,0.14);
  margin-bottom: var(--stack-gap);
}
.card-icon{
  font-size: var(--icon-size);
  margin-right: 14px;
}
.card-text{
  font-size: var(--text-size);
  color: #222;
}
.card-arrow{
  margin-left: auto;
  color: #c0c4cc;
  font-size: var(--arrow-size);
}
.card-icon.green{ color: #16a34a; }
.card-icon.orange{ color: #f59e0b; }
.card-icon.purple{ color: #8b5cf6; }
.card-icon.red{ color: #ef4444; }
.card-icon.gray{ color: #9ca3af; }
</style>